import { selectAssetById } from "@overmap-ai/core"
import { memo } from "react"

import { useAppSelector } from "../../store"
import { AssetTypeIcon } from "./AssetTypeIcon"
import type { LuIconWithWrapperProps } from "./LuIconWithWrapper"

interface AssetIcon extends Omit<LuIconWithWrapperProps, "color" | "icon"> {
	assetId: string
}

/** @deprecated Use AssetTypeIcon instead with asset.asset_type **/
export const AssetIcon = memo<AssetIcon>((props) => {
	const { ref, assetId, ...rest } = props

	const asset = useAppSelector(selectAssetById(assetId))

	return <AssetTypeIcon assetTypeId={asset?.asset_type ?? ""} ref={ref} {...rest} />
})
AssetIcon.displayName = "AssetIcon"
